import React, { useState } from "react";
import styles from "./TemplateHeader.module.css";

import { NavLink, useLocation } from "react-router-dom";
import { BrowserRoutes } from "../../constants/BrowserRoutes";

import { useContext } from "react";
import ThemeContext from "../../contexts/ThemeContext";
import MobileNavButton from "../MobileNavButton/MobileNavButton";
import ContentContainer from "../ReusableComponents/ContentContainer/ContentContainer";
import BusinessLogo from "../ReusableComponents/BusinessLogo/BusinessLogo";
import useScrollUpVisibility from "../../hooks/useScrollUpVisibility";

const StyledNavLink = (props) => {
  const theme = useContext(ThemeContext);
  const { pathname } = useLocation();
  const color =
    pathname === BrowserRoutes.HOME ? theme.whiteColor : theme.blackColor;

  const textStyle = {
    color,
    borderColor: color,
    fontFamily: props.fontFamily ?? theme.secondaryFont,
  };
  // `to` is a section id for in-page links and "/" for Home and the logo, which
  // have no matching element — scroll to the top in that case instead of
  // dereferencing null.
  const scroll = (id) => {
    const section = document.getElementById(id);
    window.scrollTo({
      top: section ? section.offsetTop : 0,
      behavior: "smooth",
    });
  };
  return (
    <NavLink
      style={textStyle}
      className={props.className ?? ""}
      to={"/"}
      onClick={() => scroll(props.to)}
    >
      {props.children}
    </NavLink>
  );
};

const NavItems = () => {
  return (
    <>
      <ul>
        <li>
          <StyledNavLink to={BrowserRoutes.HOME}>Home</StyledNavLink>
        </li>
        <li>
          <StyledNavLink to={BrowserRoutes.SERVICES}>Services</StyledNavLink>
        </li>
        <li>
          <StyledNavLink to={BrowserRoutes.OUR_WORK_FLOW}>
            Our Work Flow
          </StyledNavLink>
        </li>

        <li>
          <StyledNavLink to={BrowserRoutes.TESTIMONIALS}>
            Testimonials
          </StyledNavLink>
        </li>
      </ul>
    </>
  );
};

const TemplateHeader = () => {
  const theme = useContext(ThemeContext);
  const { pathname } = useLocation();
  const isScrollUpVisible = useScrollUpVisibility();
  const backgroundColor =
    pathname === BrowserRoutes.HOME ? theme.secondaryColor : "white";
  const logo =
    pathname === BrowserRoutes.HOME ? theme.whiteLogo : theme.coloredLogo;

  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };
  const classes = `${styles.MobileNav} ${open ? "" : styles.isHidden}`;

  return (
    <div
      id="home"
      className={styles.headerContainer}
      style={{ backgroundColor: "transparent" }}
    >
      {isScrollUpVisible && <div className={styles.gradientOverlay} />}
      <ContentContainer width={100}>
        <nav className={styles.Nav} data-testid="TemplateHeader">
          <StyledNavLink
            to={BrowserRoutes.HOME}
            className={styles.logo}
            fontFamily={theme.primaryFont}
          >
            <BusinessLogo img={logo} size={50} />
            {theme.headerTitle}
          </StyledNavLink>
          <div className={styles.DesktopNav}>
            <NavItems />
          </div>
          <StyledNavLink to={BrowserRoutes.CONTACT}>
            <button className={styles.buttonStyle}>Contact Us</button>
          </StyledNavLink>
          <MobileNavButton open={open} handleToggle={handleToggle} />
        </nav>
      </ContentContainer>
      <div
        style={{ backgroundColor }}
        data-testid="MobileNavPanel"
        className={classes}
        onClick={(e) => {
          if (e.target !== e.currentTarget) {
            handleToggle();
          }
        }}
      >
        <NavItems />
      </div>
    </div>
  );
};

export default TemplateHeader;
